/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon20Solid = forwardRef('MediaUiAPlayPauseIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m11.215 8.561-8.61-5.42C1.475 2.428 0 3.24 0 4.579v10.842c0 1.337 1.474 2.151 2.606 1.438l8.61-5.42a1.7 1.7 0 0 0 0-2.878Z" }),
        React.createElement("path", { d: "M15 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M20 4a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V4Z" })));
});
